import { initClarity, initPlausible } from "@koaform/analytics";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import App from "./App.js";
import "./styles.css";

/**
 * Production only, so local and preview sessions stay out of the data. When
 * disabled both install no-op stubs, so trackEvent/identify call sites
 * elsewhere never need a guard.
 */
const analyticsEnabled = import.meta.env.PROD;
initPlausible({ enabled: analyticsEnabled });
initClarity({ enabled: analyticsEnabled });

const root = document.getElementById("root");
if (!root) throw new Error("#root is missing from index.html");

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
